export default "__VITE_ASSET__CQix6h1V__"